import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from 'moment';
import BounceLoader from 'react-spinners/BounceLoader'
import LoadingOverlay from '../../common/Loader';
import Toaster from '../../components/Toaster';
import Header from "../../common/header";
import Footer from "../../common/footer"
import Sidebar from "../../common/sidebar"
import { downloadExcel } from "react-export-table-to-excel";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import "bootstrap-daterangepicker/daterangepicker.css";
import { api } from '../../Services/index';
const { REACT_APP_ENV } = process.env;
var apiConfig = require('../../Services/constant.json')[REACT_APP_ENV.trim()];
import { CSVLink } from "react-csv";
import AllPagesPDFViewer from "../dcg_viewer_pdf/all-pages";
import SweetAlert from 'react-bootstrap-sweetalert';
import { Pagination } from 'antd';
import getRefreshToken from '../../Services/token';
import IdleTimer from "../../common/IdleTimer";
import AssociateNotes from "../../common/associateNotes";
import AttachmentModal from "../../common/attachment";
var momentt = require('moment-timezone');

var obj = require('lodash');
// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const csvExportHeaders = [
    { label: "DCG Id", key: "dcgid" },
    { label: "Store", key: "naturalstoreid" },
    { label: "Associate", key: "salerepname" },
    { label: "Customer Name", key: 'customername' },
    { label: "Customer Email Id", key: 'customeremail' },
    { label: "Customer Phone No", key: 'customerphonenumber' },
    { label: "Customer Address", key: 'customeraddress' },
    { label: "Status", key: 'statustext' },
    { label: "Updated Date", key: 'updatedatetime' }
];

const loaderStyle = {
    color: '#f3f3f3',

};

const pdfviewerStyle = {
    BorderTop: '2px solid black',
    display: 'flex'

};

class DesignStatusReport extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            tab: 9,
            markets: [],
            stores: [],
            associates: [],
            selectedMarket: 0,
            selectedStore: [],
            selectedStatus: [],
            selectedMarketAllStores: [],
            selectedAssociate: null,
            toasterMessage: '',
            toasterType: '',
            dcgId: '',
            startDate: moment().subtract(30, 'days').format('MM/DD/YYYY'),
            endDate: moment().format('MM/DD/YYYY'),
            dateLabel: '',
            statusReportData: [],
            exportStatusData: [],
            spinnerColor: '#000000',
            spinnerLoading: false,
            userLoggedIn: false,
            loginname: null,
            userloginid: null,
            //pdf viewer
            pdfDCGIds: [],
            samplePdfFilesList: [],
            currentPdfFileUrl: apiConfig.base_url + '/dcgforms/print?dcgid=1803&type=stream',
            currentPdfFileIndex: 0,
            pageNumber: 1,
            showPdfPreview: false,
            showResultGrid: true,
            defaultPageSize: 0,
            total: 0,
            oldrequest: {}
        }
        this.changeMarket = this.changeMarket.bind(this);
        this.changevalue = this.changevalue.bind(this);
        this.changeStore = this.changeStore.bind(this);
        this.changeAssociate = this.changeAssociate.bind(this);
        this.changeStatus = this.changeStatus.bind(this);
        this.handleCalenderEvent = this.handleCalenderEvent.bind(this);
        this.handleCalenderCallback = this.handleCalenderCallback.bind(this);
        this.reset = this.reset.bind(this);
        this.showResults = this.showResults.bind(this);



        //pdf viewer
        this.viewPDF = this.viewPDF.bind(this);
        this.closePdfViewer = this.closePdfViewer.bind(this);

    }

    componentDidMount() {
        this.setUserInfo();
        this.state.diff = moment().utcOffset(moment().format().toString())._offset;
        this.state.timezonelabel = momentt.tz(momentt.tz.guess()).zoneAbbr();
        this.getMarketData();
        this.getStatusData();
        this.getStoreData(this.state.selectedMarket);
        this.getAssociateData(this.state.selectedMarket, 0);
        var searchObj = { startDate: moment(this.state.startDate).format("YYYY-MM-DD"), endDate: moment(this.state.endDate).format("YYYY-MM-DD"), statusids: [], storeids: [] };
        this.getStatusReportData(searchObj);
        this.exportall();
    }

    setUserInfo = () => {
        var userinfo = JSON.parse(localStorage.getItem('userinfo'));
        if (userinfo) {
            this.setState({
                loginname: userinfo.roleinfo.loginname,
                userloginid: userinfo.roleinfo.userloginid,
                userLoggedIn: true
            })
        } else {
            return;
        }

    }



    clickPrintPdf = () => {
        this.hiddenNotesModal(false);
        this.openAttachmentModal(false);
        window.open(this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl, "PRINT", "height=600,width=800");
    }
    hiddennotes = () => {
        this.setState({
            showHiddenNotesModal: true,
        })
        this.openAttachmentModal(false);

    }
    clickDownloadPdf = () => {
        this.hiddenNotesModal(false);
        this.openAttachmentModal(false);
        let url = new URL(this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl);
        let params = new URLSearchParams(url.search);
        params.delete('type');
        window.location.href = url.origin + '' + url.pathname + '?' + params;

    }

    // close Pdf Viewer
    closePdfViewer = () => {
        this.setState({
            showPdfPreview: false,
            showResultGrid: true,
        })
    }

    onCancelPdfViewerPopup = () => {
        this.hiddenNotesModal(false);
        this.openAttachmentModal(false);
        this.setState({
            showPdfPreview: false,
            showResultGrid: true,
        })
    }
    reset() {
        this.state.startDate = null;
        this.state.endDate = null;
        this.openAttachmentModal(false);
    }

    handleCalenderEvent(event, datepicker) {
        this.state.startDate = moment(datepicker.startDate).format("MM/DD/YYYY");
        this.state.endDate = moment(datepicker.endDate).format("MM/DD/YYYY");
        this.openAttachmentModal(false);
    }

    handleCalenderCallback(start, end, label) {
    }

    changeMarket(event) {
        this.setState({ selectedMarket: event.target.value })
        this.setState({ selectedStore: [] })
        this.getStoreData(event.target.value);
        this.setState({ selectedAssociate: null })
        this.getAssociateData(event.target.value, 0);
    }
    changevalue(e) {
        this.setState({
            dcgId: e.target.value
        });
    }
    changeStore(event) {
        var tmpStores = (Number(event.target.value) === 0 ? this.state.selectedMarketAllStores : [event.target.value]);
        tmpStores.push();
        this.setState({ selectedStore: tmpStores })
        this.setState({ selectedAssociate: null })
        this.getAssociateData(this.state.selectedMarket, event.target.value);
    }

    changeAssociate(event) {
        this.setState({
            selectedAssociate: event.target.value
        });
    }
    changeStatus(event) {
        var tmpvalue = (Number(event.target.value) === 0 ? [] : [Number(event.target.value)]);
        tmpvalue.push();
        this.setState({ selectedStatus: tmpvalue })
    }

    tabchangeevent = (e) => {
        this.setState({ tab: e })
    }

    onfieldChange = (e, key) => {

    }

    getMarketData() {
        try {
            this.setState({ spinnerLoading: true });
            api.getMarketData().then((data) => {
                this.setState({
                    markets: data.data,
                    spinnerLoading: false
                });
            }).catch((error) => {
                console.log('Error : ' + error);
            });
        } catch (e) {
        }
    }
    getStatusData() {
        try {
            this.setState({ spinnerLoading: true });
            api.getStatusesDataPost().then((data) => {
                this.setState({
                    statuses: data.data.data,
                    spinnerLoading: false
                });
            }).catch((error) => {
                console.log('Error : ' + error);
            });
        } catch (e) {
        }
    }
    getStoreData(marketId) {
        try {
            this.setState({ spinnerLoading: true });
            api.getStoreData(marketId).then((data) => {
                this.setState({
                    stores: data.data,
                    spinnerLoading: false
                });

                const arrMarketStoreIds = data.data.reduce((r, c) =>
                    (r.storeid.push(c.storeid), r.marketid.push(c.marketid), r), { storeid: [], marketid: [] })
                this.state.selectedStore = arrMarketStoreIds.storeid;
                this.state.selectedMarketAllStores = arrMarketStoreIds.storeid;
            }).catch((error) => {
                console.log('Error : ' + error);
            });
        } catch (e) {
        }
    }

    getAssociateData(marketId, storeId) {
        try {
            this.setState({ spinnerLoading: true });
            api.getAssociateData(marketId, storeId).then((data) => {
                this.setState({
                    associates: data.data,
                    spinnerLoading: false
                });
            }).catch((error) => {
                console.log('Error : ' + error);
            });
        } catch (e) {
        }

    }


    getStatusReportData(searchParam) {
        try {
            this.setState({ spinnerLoading: true });
            var actionPayload = searchParam;
            this.state.oldrequest = actionPayload;
            api.getDesignerAppointmentReportsDataPost(actionPayload).then((data) => {
                if (data && data.response && data.response.status == 401) {
                    this.getrefreshtoken(actionPayload);
                }
                else {
                    this.setState({
                        statusReportData: (data.data.data.reports) ? data.data.data.reports : [],
                        spinnerLoading: false,
                        defaultPageSize: data.data.data.limit,
                        total: data.data.data.totalCount
                    });
                }
            }).catch((error) => {
                console.log('Error : ' + error);
                this.setState({
                    spinnerLoading: false
                });
                this.toggleToaster("Failed to retrieve data from the API. Please try again later.", "error");

            });
        } catch (e) {
        }
    }
    toggleToaster(message, type) {

        this.setState({
            toasterMessage: message,
            toasterType: type
        })

        setTimeout(() => {
            this.setState({
                toasterMessage: null,
                toasterType: undefined
            })
        }, 4000);
    }
    getrefreshtoken(actionPayload) {
        getRefreshToken()
            .then(res => {
                if (actionPayload) {
                    api.getDesignerAppointmentReportsDataPost(actionPayload).then((data) => {
                        this.setState({
                            statusReportData: (data.data.data.reports) ? data.data.data.reports : [],
                            spinnerLoading: false,
                            defaultPageSize: data.data.data.limit,
                            total: data.data.data.totalCount
                        });
                        this.getMarketData();
                        this.getStatusData();
                        this.getStoreData(this.state.selectedMarket);
                        this.getAssociateData(this.state.selectedMarket, 0);
                        this.exportall();
                    }).catch((error) => {
                        console.log('Error : ' + error);
                    });
                }
                else {
                    this.changedcgstatus()
                }
            })
            .catch(err => {
                this.props.history.push('/login');
            })
    }
    
    onChange = (page, pageSize) => {
        if (page) {
            this.state.pageNumber = page;

        }
        this.showResults();
    }

    exportall = () => {
        var searchObj = {};
        if (this.state.dcgId !== '') {
            searchObj['dcgid'] = this.state.dcgId;
        }
        else {
            searchObj['dcgid'] = null;
        }
        if (this.state.startDate) {
            searchObj['startDate'] = moment(this.state.startDate).format("YYYY-MM-DD");
        }
        else {
            searchObj['startDate'] = moment().subtract(30, 'days').format('MM/DD/YYYY');
            (this.state.dcgId == '') ? (this.state.startDate = moment().subtract(30, 'days').format('MM/DD/YYYY')) : '';
        }
        if (this.state.endDate) {
            searchObj['endDate'] = moment(this.state.endDate).format("YYYY-MM-DD");
        }
        else {
            searchObj['endDate'] = moment().format('MM/DD/YYYY');
            (this.state.dcgId == '') ? (this.state.endDate = moment().format('MM/DD/YYYY')) : '';
            this.openAttachmentModal(false);
        }
        if (this.state.selectedStore.length != -1) {
            searchObj['storeids'] = this.state.selectedStore;
        }
        else {
            searchObj['storeids'] = [];
        }
        if (this.state.selectedAssociate) {
            searchObj['salesrepid'] = (Number(this.state.selectedAssociate) === 0 ? null : this.state.selectedAssociate);
        }
        else {
            searchObj['salesrepid'] = null;
        }

        if (this.state.selectedStatus.length != -1) {
            searchObj['statusids'] = this.state.selectedStatus;
        }

        searchObj['type'] = "export";
        api.getDesignerAppointmentReportsDataPost(searchObj).then((data) => {
            this.setState({
                exportStatusData: (data.data.data.reports) ? data.data.data.reports : [],
                spinnerLoading: false,
            });
        }).catch((error) => {
            console.log('Error : ' + error);
        });
    }

    showResults = () => {
        var searchObj = {};
        if (this.state.dcgId !== '') {
            searchObj['dcgid'] = this.state.dcgId;
        }
        else {
            searchObj['dcgid'] = null;
        }

        if (this.state.selectedStore.length != -1) {
            searchObj['storeids'] = this.state.selectedStore;
        }
        else {
            searchObj['storeids'] = [];
        }
        if (this.state.selectedAssociate) {
            searchObj['salesrepid'] = (Number(this.state.selectedAssociate) === 0 ? null : this.state.selectedAssociate);
        }
        else {
            searchObj['salesrepid'] = null;
        }
        if (this.state.startDate) {
            searchObj['startDate'] = moment(this.state.startDate).format("YYYY-MM-DD");
        }
        else {
            searchObj['startDate'] = moment().subtract(30, 'days').format('MM/DD/YYYY');
            (this.state.dcgId == '') ? (this.state.startDate = moment().subtract(30, 'days').format('MM/DD/YYYY')) : '';
        }
        if (this.state.endDate) {
            searchObj['endDate'] = moment(this.state.endDate).format("YYYY-MM-DD");
        }
        else {
            searchObj['endDate'] = moment().format('MM/DD/YYYY');
            (this.state.dcgId == '') ? (this.state.endDate = moment().format('MM/DD/YYYY')) : '';
            this.openAttachmentModal(false);
        }
        if (this.state.selectedStatus.length != -1) {
            searchObj['statusids'] = this.state.selectedStatus;
        }
        if (this.state.pageNumber > 1) {
            searchObj['pageNumber'] = this.state.pageNumber;
            searchObj['totalCount'] = this.state.total;
        }
        if ((!(obj.isEqual(this.state.oldrequest, searchObj))) || (this.state.validSearch && this.state.validSearch == true)) {
            this.getStatusReportData(searchObj);
            this.setState({ validSearch: false });
            if (!('pageNumber' in searchObj)) {
                this.exportall();
            }
        }




    }

    renderTableHeader() {
        var header = [];
        header = this.state.statusReportData[0] && Object.keys(this.state.statusReportData[0]);
        return (
            <tr key='tabheader'>
                <th>DCG Id</th>
                <th>Store</th>
                <th>Associate</th>
                <th>Customer Name</th>
                <th>Customer Email Id</th>
                <th>Customer Phone No</th>
                <th>Customer Address</th>
                <th>Status</th>
                <th>Updated Date</th>
            </tr>

        )
    }
    openFN = async (dcgid) => {
        this.setState({ showAttachmentModal: true });
        this.hiddenNotesModal(false);
    }

    renderTableData() {
        return this.state.statusReportData && this.state.statusReportData.map((data, i) => {
            const { dcgid, naturalstoreid, salerepname, customername, customeremail, storeid, customerphonenumber, customeraddress, updatedatetime, statustext, colorcode } = data;
            return (

                <tr >
                    <td className="dcgid">{(dcgid === null || dcgid === '0') ? 0 : <a href='javascript:void(0);' onClick={(e) => this.viewPDF(dcgid, e)}>{(dcgid)}</a>}
                        {/* <i onClick={()=> { this.openFN()}  } className="fa fa-paperclip" style={{cursor:'pointer'}}></i> */}
                    </td>
                    <td>{(naturalstoreid === null) ? '' : naturalstoreid}</td>
                    <td>{(salerepname === null) ? '' : salerepname}</td>
                    <td>{(customername === null) ? '' : customername}</td>
                    <td>{(customeremail === null) ? '' : customeremail}</td>
                    <td>{(customerphonenumber === null) ? '' : customerphonenumber}</td>
                    <td>{(customeraddress === null) ? '' : customeraddress}</td>
                    <td style={this.state.statusReportData[i].statustext == 'Design' || this.state.statusReportData[i].statustext == 'Follow Up' ? { backgroundColor: colorcode, textAlign: 'center',color:'white', width: '130px'} : { backgroundColor: colorcode, textAlign: 'center' , color:'black', width: '130px'}}>{(statustext === null) ? '' : statustext}</td>
                    <td>{(updatedatetime === null) ? '' : moment(updatedatetime).tz("America/New_York").format("MM-DD-YYYY h:mm a")}</td>

                </tr>

            )
        })
    }



    formatStoreNumber = (number) => {
        return String(number).padStart(3, '0');
    }
    renderTable() {
        return (
            <div id="daily-summary-table">
                <table class="table table-bordered table-striped" id="table-data">
                    <thead>
                        {this.renderTableHeader()}
                    </thead>
                    <tbody>
                        {this.renderTableData()}
                    </tbody>
                </table>
            </div>
        )
    }
    hiddenNotesModal = (flag) => {
        this.setState({ showHiddenNotesModal: flag });
    }
    openAttachmentModal = (flag) => {
        this.setState({ showAttachmentModal: flag });
    }

    viewPDF = (dcgids, e) => {

        e.preventDefault();
        var arrdcgids = dcgids;
        const tmpPdfUrls = [];
        this.setState({ pdfDCGIds: arrdcgids }, () => {
            tmpPdfUrls.push({ dcgid: this.state.pdfDCGId, fileurl: apiConfig.base_url + '/dcgforms/print?dcgid=' + this.state.pdfDCGIds + '&type=stream' + '&timezonediff=' + this.state.diff + '&timezonelabel=' + this.state.timezonelabel });


            this.setState(
                {
                    samplePdfFilesList: tmpPdfUrls,
                    currentPdfFileUrl: tmpPdfUrls.fileurl,
                    currentPdfFileIndex: 0,
                    btnPrevPdfDisabled: true,
                    btnNextPdfDisabled: (tmpPdfUrls.length <= 1),
                    showPdfPreview: true,
                    showResultGrid: false,
                }, () => {
                    console.log('set state')
                    // console.log(this.state)
                });

        });
    }
    handleDownloadExcel = () => {
        var obj = {
            dcgid: "DCG Id",
            naturalstoreid: "Store",
            salerepname: "Associate",
            customername: "Customer Name",
            customeremail: "Customer Email",
            customerphonenumber: "Customer Phone No",
            customeraddress: 'Customer Address',
            statustext: "Status",
            updatedatetime: "Updated Date",
        }
        const header = ['DCG Id', 'Store', 'Associate', 'Customer Name', 'Customer Email Id', 'Customer Phone No', 'Customer Address', 'Status', 'Updated Date'];
        var dataInXl = [];
        this.state.exportStatusData.map((c, i) => {
            for (var key in obj) {
                if (!dataInXl[i]) {
                    dataInXl[i] = [];
                    dataInXl[i].push(c[key]);
                } else {
                    if (key == 'updatedatetime') {
                        let data = moment(c[key]).tz("America/New_York").format("MM-DD-YYYY h:mm a");
                        dataInXl[i].push(data);
                    } else {
                        dataInXl[i].push(c[key]);
                    }
                }
            }

        });
        downloadExcel({
            fileName: "Design_Status_Report",
            sheet: "Design_Status_Report",
            tablePayload: {
                header,
                // accept two different data structures
                body: dataInXl || body2,
            },
        });
    }

    render() {
        return (

            <div className="wrapper" >
                <LoadingOverlay active={this.state.spinnerLoading} spinner={<BounceLoader />} className={loaderStyle} >
                    <Header />
                    <Sidebar tab={this.state.tab} tabchangeevent={this.tabchangeevent} />
                     <IdleTimer ></IdleTimer>
                    {this.state.showHiddenNotesModal && <AssociateNotes dcgId={this.state.pdfDCGIds} hiddenNotesModal={this.hiddenNotesModal} />}
                    {this.state.showAttachmentModal && <AttachmentModal dcgId={this.state.pdfDCGIds} openAttachmentModal={this.openAttachmentModal} />}
                    <div className="content-wrapper pb-4">
                        {this.state.toasterMessage ? <Toaster message={this.state.toasterMessage} toasterType={this.state.toasterType} /> : null}
                        {(this.state.showResultGrid === true) && (
                            <section class="content">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <h5>Design Status Report</h5>
                                        </div>
                                        <div class="col-md-4  alertStyle">
                                            <p class="alertStyle">* All the reports are displaying in EST timezone</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <hr />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label>Market</label>
                                                <select className="form-control" value={this.state.selectedMarket} onChange={this.changeMarket}>
                                                    <option value={0}>All</option>
                                                    {
                                                        this.state.markets && this.state.markets.map((market, key) => (
                                                            <option
                                                                value={market.marketid}>{market.marketname}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label>Store</label>
                                                <select className="form-control" value={this.state.selectedStore} onChange={this.changeStore}>
                                                    <option value={0}>All</option>
                                                    {
                                                        this.state.stores && this.state.stores.map((str, key) => (
                                                            <option
                                                                value={str.storeid}>{this.formatStoreNumber(str.naturalstoreid)}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label>Associate</label>
                                                <select className="form-control" value={this.state.selectedAssociate} onChange={this.changeAssociate}>
                                                    <option value={0}>All</option>
                                                    {
                                                        this.state.associates && this.state.associates.map((asst, key) => (
                                                            <option
                                                                value={asst.userloginid}>{asst.loginname}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Date Range</label>
                                                <div class="input-group">
                                                    <DateRangePicker onEvent={this.handleCalenderEvent1} onChange={this.handleCalenderEvent1} onApply={this.handleCalenderEvent} initialSettings={{ startDate: this.state.startDate, endDate: this.state.endDate }}>
                                                        <input type="text" className="form-control" value={(this.state.startDate && this.state.endDate) ? this.state.startDate + ' - ' + this.state.endDate : ''} />
                                                    </DateRangePicker>
                                                    {this.state.startDate && this.state.endDate && <i onClick={this.reset} className="fa fa-times" style={{ marginLeft: '5%', color: '#2470af' }}></i>}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label>Status</label>
                                                <select className="form-control" value={this.state.selectedStatus} onChange={this.changeStatus}>
                                                    <option value={0}>All</option>
                                                    {
                                                        this.state.statuses && this.state.statuses.map((status, key) => (
                                                            <option
                                                                value={status.statusid}>{status.status}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label>DCG Id</label>
                                                <div class="input-group">
                                                    <input type="text" className="form-control" placeholder="DCG Id" value={this.state.dcgId} onChange={this.changevalue} />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group mt-1 pt-4">
                                                <a href="#" onClick={() => { this.state.pageNumber = 1, this.showResults() }} class="btn btn-primary">Show</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <hr />
                                        </div>
                                    </div>
                                    {this.state.showpopStatus && <div onClick={() => this.setState({ showpopStatus: false })} style={{ position: 'absolute', height: 2000, width: '100%', left: -10, right: -10, background: '#000', opacity: 0.5, zIndex: 1 }}>
                                    </div>}

                                    <div class="row">
                                        {!(Object.entries(this.state.exportStatusData).length === 0) && (
                                            <div class="col-md-12 text-right">
                                                <label>Export : &nbsp; </label>
                                                <img src="dist/img/excel-icon.png" className="pointer" title="Export to Excel" onClick={() => { this.handleDownloadExcel() }} />
                                                {/* <ExcelFile element={<a href="javascript:void(0);" class="mr-2">
                                                    <img src="dist/img/excel-icon.png" title="Export to Excel" filename="Status_Report" /></a>}>
                                                    <ExcelSheet data={this.state.exportStatusData} name="Status_Report">
                                                        <ExcelColumn label="DCG Id" value={(col) => (col.dcgid === null) ? "0" : col.dcgid} />
                                                        <ExcelColumn label="Store" value={(col) => (col.naturalstoreid === null) ? "" : col.naturalstoreid} />
                                                        <ExcelColumn label="Associate" value={(col) => (col.salerepname === null) ? "" : col.salerepname} />
                                                        <ExcelColumn label="Customer Name" value={(col) => (col.customername === null) ? "" : col.customername} />
                                                        <ExcelColumn label="Customer Email Id" value={(col) => (col.customeremail === null) ? "" : col.customeremail} />
                                                        <ExcelColumn label="Customer Phone No" value={(col) => (col.customerphonenumber === null) ? "" : col.customerphonenumber} />
                                                        <ExcelColumn label="Status" value={(col) => (col.statustext === null) ? "" : col.statustext} style={{ fill: { patternType: "solid", fgColor: { rgb: "FF00FF00" } } }} />
                                                        <ExcelColumn label="Updated Date" value={(col) => (col.updatedatetime === null) ? "" : moment(col.updatedatetime).tz("America/New_York").format("MM-DD-YYYY h:mm a")} />
                                                    </ExcelSheet>
                                                </ExcelFile> */}

                                                <CSVLink
                                                    headers={csvExportHeaders}
                                                    data={this.state.exportStatusData && this.state.exportStatusData.map(row => ({
                                                        ...row
                                                        , dcgid: ((row.dcgid === null) ? "0" : row.dcgid)
                                                        , naturalstoreid: ((row.naturalstoreid === null) ? "" : row.naturalstoreid)
                                                        , salerepname: ((row.salerepname === null) ? "" : row.salerepname)
                                                        , customername: ((row.customername === null) ? "" : row.customername)
                                                        , customeremail: ((row.customeremail === null) ? "" : row.customeremail)
                                                        , customerphonenumber: ((row.customerphonenumber === null) ? "" : row.customerphonenumber)
                                                        , customeraddress: ((row.customeraddress === null) ? "" : row.customeraddress)
                                                        , statustext: ((row.statustext === null) ? "" : row.statustext)
                                                        , updatedatetime: ((row.updatedatetime === null) ? "" : moment(row.updatedatetime).tz("America/New_York").format("MM-DD-YYYY h:mm a"))
                                                    }))}
                                                    filename='Design_Status_Report.csv'>
                                                    <img src="dist/img/csv-icon.png" title="Export to CSV" />
                                                </CSVLink>

                                            </div>
                                        )}
                                        {!(Object.entries(this.state.statusReportData).length === 0) && (
                                            <div class="col-md-12">
                                                {this.renderTable()}

                                            </div>
                                        )}
                                        {!(Object.entries(this.state.statusReportData).length === 0) && (
                                            <div class="row">
                                                <div class="col-md-12 text-right">
                                                    <Pagination
                                                        total={this.state.total}
                                                        showTotal={total => `Total ${total} items`}
                                                        defaultPageSize={this.state.defaultPageSize}
                                                        current={this.state.pageNumber}
                                                        onChange={this.onChange}
                                                        showSizeChanger={false}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {(Object.entries(this.state.statusReportData).length === 0) && (
                                            <div class="col-md-12">
                                                Sorry, No Records found!
                                            </div>
                                        )}


                                    </div>

                                </div>
                            </section>
                        )}

                        {(this.state.showPdfPreview === true) && (
                            <div >
                                <SweetAlert
                                    showConfirm={false}
                                    onCancel={this.onCancelPdfViewerPopup}
                                    style={{ color: '#000000', fontSize: '11px', minWidth: '80%', marginTop: '30px', overflow: 'auto', overflowY: 'visible' }}
                                    closeOnClickOutside={true}
                                    allowEscape={true}
                                    btnSize={'sm'}
                                    customClass="containerBox"
                                >
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h5 style={{ textAlign: 'right', color: '#2470af', cursor: 'pointer', fontSize: '28px' }} onClick={this.onCancelPdfViewerPopup}> <i class="fas fa-times"></i></h5>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">

                                        </div>
                                        <div class="col-md-8" style={{ textAlign: 'center' }}>
                                            <h4 >DCG Viewer</h4>
                                        </div>
                                        <div class="col-md-2" style={{ textAlign: 'right' }}>
                                            <a>
                                                <img src={require('../../dist/img/iconnotes.png')} className="mr-3 notecolor" style={{ marginBottom: 10, cursor: 'pointer' }} onClick={this.hiddennotes} data-toggle="modal" data-target="#hiddennotes" />
                                            </a>
                                            <i onClick={() => { this.openFN() }} className="fa fa-paperclip attachment-pop" style={{ cursor: 'pointer' }}></i>
                                            <a href="javascript:void(0);" class="mr-3" onClick={this.clickPrintPdf}><i className="fas fa-print fa-2x text-color"></i></a>
                                            <a href="javascript:void(0);" class="mr-2" onClick={this.clickDownloadPdf}><i className="fas fa-download fa-2x text-color"></i></a>
                                        </div>
                                    </div>

                                    <div class="row">

                                    </div>
                                    <div class="col-md-12">
                                        &nbsp;<br></br>&nbsp;
                                    </div>
                                    <div class="col-md-12 react-pdf__Document_p">
                                        <AllPagesPDFViewer pdf={this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl} />
                                    </div>
                                </SweetAlert>

                            </div>

                        )}

                    </div>
                </LoadingOverlay>

                <Footer />
                <aside className="control-sidebar control-sidebar-dark">
                </aside>
            </div>
        );
    }
}
export default withRouter(DesignStatusReport);